module.exports = __webpack_public_path__ + "static/media/loading-spinner-pulse-2x.a88cd1d0.gif";